import { makeStyles } from "@material-ui/core/styles";
import { colors } from "~/utils/colors";

const { background, brand } = colors;

export default makeStyles(() => ({
  "@keyframes slideUp": {
    from: {
      transform: "translateY(70vh)",
      opacity: 0,
    },
    to: {
      transform: "translateY(0)",
      opacity: 1,
    },
  },

  container: {
    position: "fixed",
    width: "100%",
    maxWidth: 480,
    left: 0,
    right: 0,
    bottom: 0,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    padding: "20px 20px 12px 20px",
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.2)",
    backgroundColor: background?.default || "#FDFCF8",
    animation: "$slideUp 0.6s ease-out",
    maxHeight: "85vh",
    overflowY: "auto",
    zIndex: 1300,
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: 12,
    minHeight: "40px",
    gap: 12,
  },

  closeButton: {
    cursor: "pointer",
    padding: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    transition: "background-color 0.2s ease",
    width: "40px",
    height: "40px",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.1)",
    },
  },

  content: {
    padding: "4px 0 24px 0",
  },

  buttons: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    paddingBottom: 24,
  },

  primaryButton: {
    width: "100%",
    backgroundColor: brand?.default || "#8C1837",
    color: "#fff",
    textTransform: "none",
    fontWeight: "bold",
    fontFamily: "CircularStd",
    padding: "8px 20px",
    borderRadius: "100px",
    fontSize: "clamp(16px, 2vw, 20px)",
    boxShadow: "none",
    border: "none",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: brand?.dark || "#5A0F22",
    },
  },

  secondaryButton: {
    width: "100%",
    backgroundColor: background?.default || "#FDFCF8",
    color: brand?.default || "#8C1837",
    textTransform: "none",
    fontWeight: "bold",
    fontFamily: "CircularStd",
    padding: "8px 20px",
    borderRadius: "100px",
    fontSize: "clamp(16px, 2vw, 20px)",
    boxShadow: "none",
    border: `1.5px solid ${brand?.default || "#8C1837"}`,
    cursor: "pointer",
  },
}));
